import { render } from "./RefundStatus.vue?vue&type=template&id=06c310e4&scoped=true"
import script from "./RefundStatus.vue?vue&type=script&lang=js"
export * from "./RefundStatus.vue?vue&type=script&lang=js"

import "./RefundStatus.vue?vue&type=style&index=0&id=06c310e4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c310e4"]])

export default __exports__